import styled from '@emotion/styled';

interface LabelProps {
  selected: boolean;
}

export const Label = styled.div<LabelProps>`
  font-weight: ${props => (props.selected ? 'bold' : 'unset')};
  margin-right: auto;
`;
